export type Icd10Code = {
    code: string;
    description: string;
};

export function isIcd10Code(value: unknown): value is Icd10Code {
    return (
        typeof value === 'object' &&
        value !== null &&
        'code' in value &&
        typeof value.code === 'string' &&
        'description' in value &&
        typeof value.description === 'string'
    );
}

export const UNKNOWN_DIAGNOSIS_CODE = 'R69';

const separator = ' ';

export function createLabel(icd10Code: Icd10Code): string {
    if (icd10Code.code === UNKNOWN_DIAGNOSIS_CODE) {
        return icd10Code.description;
    }

    return `${icd10Code.code}${separator}${icd10Code.description}`;
}

export function getDescriptionFromLabel(label: string): string {
    return label.split(separator).slice(1).join(separator);
}
